module.exports = __webpack_public_path__ + "static/media/22ESCWA5.1df1f25b.jpg";